import { motion } from "framer-motion";
import { Phone, ArrowUpRight } from "lucide-react";
import { PHONE_TEL } from "@/lib/site";

export default function StickyCta() {
  return (
    <motion.div
      initial={{ y: 80 }}
      animate={{ y: 0 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 120, damping: 16 }}
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t-2 border-white/15 bg-[#09090b]/95 backdrop-blur-xl md:hidden"
      data-testid="sticky-mobile-cta"
    >
      <a
        href={PHONE_TEL}
        data-testid="sticky-call-button"
        className="flex items-center justify-center gap-2 bg-[#adff01] py-4 font-display text-xs uppercase tracking-wide text-black"
      >
        <Phone className="h-4 w-4" strokeWidth={2.5} />
        Call Now
      </a>
      <a
        href="#book-it-in"
        data-testid="sticky-book-button"
        className="flex items-center justify-center gap-2 bg-[#ff66c4] py-4 font-display text-xs uppercase tracking-wide text-black"
      >
        Book Online
        <ArrowUpRight className="h-4 w-4" strokeWidth={3} />
      </a>
    </motion.div>
  );
}
